import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const LineClampStyle = styled.div.withConfig({
  displayName: "LineClamp__LineClampStyle",
  componentId: "sc-4v3ure-0"
})(["display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:", ";overflow:hidden;"], ({
  maxLines
}) => maxLines);

/**
 * @description LineClamp can be used to truncate string children to a specified
 * number of lines.
 */
const LineClamp = ({
  children,
  maxLines
}) => {
  return /*#__PURE__*/_jsx(LineClampStyle, {
    maxLines: maxLines,
    children: children
  });
};
LineClamp.displayName = 'LineClamp';
export default LineClamp;